import { render, staticRenderFns } from "./Lp1.vue?vue&type=template&id=56f69c16&scoped=true"
import script from "./Lp1.vue?vue&type=script&lang=js"
export * from "./Lp1.vue?vue&type=script&lang=js"
import style0 from "./Lp1.vue?vue&type=style&index=0&id=56f69c16&prod&lang=scss"
import style1 from "./Lp1.vue?vue&type=style&index=1&id=56f69c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f69c16",
  null
  
)

export default component.exports